import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const RepeatIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <path className={classes.element} d="M2.7984,8l.31579-.588A9.99958,9.99958,0,1,1,2.0494,13" />
      <polyline className={classes.element} points="2 4 2 8 6 8" />
    </svg>
  );
};

export default RepeatIcon;
